import { Component, inject, input, output, SecurityContext } from '@angular/core';
import { IconBigMediumChatbot, IconBigMediumHinweis, IconComponent } from '@big-direkt/utils/icons';
import { UiSpinnerModule } from '@big-direkt/ui/spinner';
import { UiButtonComponent } from '@big-direkt/ui/button';
import { ChatService } from '../../../services/chat.service';
import { Message } from '../../../interfaces/message';
import { MessageButton } from '../../../interfaces/message-button';
import { SanitizePipe } from '@big-direkt/utils/shared';

@Component({
    selector: 'big-chat-bot-message',
    templateUrl: './message.component.html',
    imports: [IconComponent, UiSpinnerModule, UiButtonComponent, SanitizePipe],
    host: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '[class]': 'classList()',
    },
})
export class MessageComponent {
    private readonly chatService = inject(ChatService);

    public readonly buttonClick = output<MessageButton>();
    public readonly classList = input('block');
    public readonly config = this.chatService.config;
    public readonly error = input<boolean>();
    public readonly errorButtonClick = output<Message>();
    public readonly iconChatBot = IconBigMediumChatbot;
    public readonly iconHint = IconBigMediumHinweis;
    public readonly message = input.required<Message>();
    public readonly securityContext = SecurityContext;

    public onButtonClick(button: MessageButton): void {
        this.buttonClick.emit(button);
        this.message().buttons = [];
    }

    public onErrorButtonClick(message: Message): void {
        this.errorButtonClick.emit(message);
    }

    public getImage(): string {
        const message = this.message();

        return message.image && !message.image.includes('www.youtube.com') ? message.image : '';
    }

    public getVideo(): string {
        const message = this.message();

        return message.image?.includes('www.youtube.com') ? message.image.replace('watch?v=', 'embed/') : '';
    }
}
